export default __webpack_public_path__ + "media/49207ef46d0b702f6efd6d9116b7b8b23ca04097bfbb44a459fa4da5f7af5691.svg";